import { render, staticRenderFns } from "./project-card.vue?vue&type=template&id=0f8355da&"
import script from "./project-card.vue?vue&type=script&lang=js&"
export * from "./project-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports